module.exports = __webpack_public_path__ + "assets/58f5f4d81476f35930feeca619f04d2a.png";